<template>
  <div class="modal">
    <div class="modal__bg" @click="$emit('close')"></div>
    <div
      class="modal__body"
      :style="{
        width:
          this.$route.matched[0].name === 'concierge' ? 380 + 'px' : 450 + 'px'
      }"
    >
      <h4 class="modal__header">
        Settings
        <img
          @click="$emit('close')"
          src="~@/assets/media/icons/close.svg"
          alt="close icon"
        />
      </h4>
      <div class="form-group">
        <label>Dashboard Color Scheme</label>
      </div>
      <div class="d-flex justify-content-center">
        <div
          class="scheme-wrapper"
          :class="{ selected: selectedScheme.id === scheme.id }"
          v-for="scheme in schemes"
          :key="scheme.id"
          @click="handleChooseTheme(scheme)"
        >
          <div
            class="circle -outer"
            :style="{ 'background-color': scheme.secondary }"
          >
            <div
              class="circle -inner"
              :style="{ 'background-color': scheme.primary }"
            ></div>
          </div>
        </div>
      </div>
      <div class="row submit-row ">
        <div class="col">
          <ActionButton
            label="Save"
            @customEvent="handleThemeSelect"
            style="width: auto; margin-left: auto;"
            :theme="{ primary, secondary, event }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "Settings",
  components: {
    ActionButton
  },
  data() {
    return {
      schemes: [
        {
          id: 0,
          primary: "#51B67E",
          secondary: "#E1FAF4",
          event: "##2A774C",
          danger: "#dc3545"
        },
        {
          id: 1,
          primary: "#EF6637",
          secondary: "#FDEFDB",
          event: "#F24408",
          danger: "#dc3545"
        },
        {
          id: 2,
          primary: "#0099F2",
          secondary: "#E8F4FA",
          event: "#0077BC",
          danger: "#dc3545"
        }
      ],
      style: {},
      selectedScheme: {}
    };
  },
  computed: {
    ...mapGetters(["currentScheme", "getUser"]),
    ...mapState(["scheme"]),
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    savedScheme() {
      return this.$store.state.concierge.schemeList;
    }
  },
  async created() {
    await this.$store.dispatch("fetchScheme", this.getUser.id);
    this.selectedScheme = this.currentScheme;
  },
  methods: {
    ...mapActions(["updateScheme"]),
    handleChooseTheme(params) {
      this.selectedScheme = params;
    },
    handleThemeSelect() {
      this.updateScheme(this.selectedScheme);
      let form = {
        userId: this.getUser.id,
        key: this.selectedScheme.id,
        value: JSON.stringify(this.selectedScheme)
      };
      this.handleSubmitScheme(form);
      this.$swal({
        type: "success",
        text: "Theme changed!"
      }).then(() => {
        this.$emit("close");
      });
    },
    async handleSubmitScheme(form) {
      await this.$store.dispatch("postScheme", form);
    },
    handleFileUpload(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.fileName = file.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.scheme-wrapper {
  cursor: pointer;
  margin-right: 20px;
  .circle {
    border: 3px solid transparent;
    border-radius: 50%;
    height: 50px;
    transition: all 0.2s linear;
    width: 50px;
    &.-outer {
      align-items: center;
      display: flex;
      justify-content: center;
    }
    &.-inner {
      height: 30px;
      transform: scale(0.8);
      transition: transform 0.2s linear;
      width: 30px;
    }
  }
  &:last-child {
    margin-right: 0;
  }
  &:hover,
  &.selected {
    .circle {
      &.-outer {
        border-color: $gray-700;
      }
      &.-inner {
        transform: scale(1);
      }
    }
  }
}

.h-0 {
  height: 0;
}
.modal {
  display: block;
  min-height: 100vh;
  left: 0;
  width: 100%;
  &__bg {
    background-color: black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  &__body {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 450px;
    z-index: 1;
  }
  &__header {
    color: $gray-900;
    font-size: $font-size-base;
    position: relative;
    img {
      cursor: pointer;
      top: 0;
      position: absolute;
      right: 0;
    }
  }
}

.upload-wrapper {
  margin-top: 16px;
  label {
    margin-bottom: 16px;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
